import { HP, legSwing, pt } from '../enemy-parts';
/* ============================================================
   家族 WALL 壁 —— 直立大平面
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     SCHILD  azu 盾衛　防護・擋線
     RAMME   red 撞槌　突進・撞擊
     LUKE    amb 艙門　掩體・射擊
     PFORTE  vio 門　深層・可穿透的牆

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var WALL = [
  /* ─ 3 ─────────────────────────────────────────────────────────
     SCHILD 盾衛 —— 剪影是一面「牆」，全表唯一的垂直大矩形。
     青色＝牠自己不傷你。玩家要學的是「繞後」而不是「多打幾發」。 */
  {
    id:'schild', fam:'wall', code:'SCHILD', zh:'盾衛', role:'防護・擋線', tint:'azu',
    sil:'直立矩形盾', h:1.54, w:1.32, wt:1.0,
    spd:1.35, turn:2.6, gait:1.5, rng:2.0, tTel:0.55, tAtk:0.30, tRec:0.80,
    q0:{lg:1, sh:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'塔盾', q:{sh:1.26}, sp:0.72, sc:1.10},
          {n:'游擊', q:{sh:0.80}, sp:1.50, sc:0.90}],
    parts:[
      pt('box','armor',[1.22,1.32,0.16],[0,0.84,0.42],[-0.10,0,0], function(P,o){
          P.sx *= o.q.sh; P.sy *= o.q.sh; P.z += o.tel*0.22; P.rx -= o.tel*0.14; }),
      pt('bev','armor',[0.12,1.38,0.12],[0.60,0.84,0.47],[-0.10,0,0], function(P,o){
          P.sy *= o.q.sh; P.x *= o.q.sh; }),
      pt('bev','dark', [0.56,0.76,0.54],[0,0.76,-0.14],null, function(P,o){
          P.ry += 0.14*Math.sin(o.ph*Math.PI * 2)*o.mv; }),
      pt('box','glow', [0.19,0.09,0.09],[0,1.24,0.02],null, function(P,o){
          P.sx *= 1 + 1.4*o.tel; }),
      pt('cyl','trim', [0.14,0.76,0.14],[ 0.25,0.38,-0.18],null, legSwing( 1,0.38,0.30)),
      pt('cyl','trim', [0.14,0.76,0.14],[-0.25,0.38,-0.18],null, legSwing(-1,0.38,0.30))
    ],
    ex:[ pt('box','armorE',[1.30,0.20,0.20],[0,1.52,0.44],[-0.10,0,0]),
         pt('box','armorE',[0.20,1.20,0.20],[-0.60,0.84,0.47],[-0.10,0,0]),
         pt('cone','armorE',[0.17,0.40,0.17],[ 0.52,1.42,0.42],[-0.10,0,-0.2]),
         pt('cone','armorE',[0.17,0.40,0.17],[-0.52,1.42,0.42],[-0.10,0, 0.2]),
         pt('box','glowE',[0.06,1.06,0.06],[0,0.84,0.52],[-0.10,0,0]) ],
    pose:function(o){
      o.ry = 0.03*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = 0.02 - o.tel*0.06;
      o.rr = 0.09*Math.sin(o.ph*Math.PI * 2)*o.mv;
      o.rz = o.tel*0.10 + o.atk*0.55;
    }
  },
  /* ── 家族 WALL 壁 ── 直立大平面。azu 是 SCHILD。 */
  {
    id:'ramme', fam:'wall', code:'RAMME', zh:'撞槌', role:'突進・撞擊', tint:'red',
    sil:'直立矩形＋後方撞桿', h:1.52, w:1.22, wt:1.3,
    spd:2.0, turn:1.6, gait:2.0, rng:2.4, tTel:0.58, tAtk:0.26, tRec:0.85,
    q0:{lg:1, sh:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'輕撞', q:{sh:0.82}, sp:1.42, sc:0.88},
          {n:'重槌', q:{sh:1.24}, sp:0.72, sc:1.18}],
    parts:[
      pt('box','armor',[1.10,1.02,0.20],[0,0.94,0.34],[-0.10,0,0], function(P,o){
          P.sx *= o.q.sh; P.sy *= o.q.sh; P.z += o.atk*0.42 - o.tel*0.16; }),
      pt('box','glow', [0.10,0.86,0.06],[0.30,0.94,0.46],[-0.10,0,0], function(P,o){
          P.sy *= o.q.sh; P.z += o.atk*0.42 - o.tel*0.16;
          P.sx *= 1 + 2.0*o.tel; }),
      pt('bev','dark', [0.56,0.52,0.60],[0,0.92,-0.16]),
      pt('cyl','trim', [0.22,0.70,0.22],[0,0.94,0.06],[HP,0,0], function(P,o){
          P.z += o.atk*0.42 - o.tel*0.20; }),
      pt('cyl','armor',[0.24,0.72,0.24],[ 0.30,0.36,-0.06],null, legSwing( 1,0.36,0.36)),
      pt('cyl','armor',[0.24,0.72,0.24],[-0.30,0.36,-0.06],null, legSwing(-1,0.36,0.36))
    ],
    ex:[ pt('box','armorE',[0.26,0.94,0.16],[ 0.62,0.94,0.28],[-0.10,0,-0.22]),
         pt('box','armorE',[0.26,0.94,0.16],[-0.62,0.94,0.28],[-0.10,0, 0.22]) ],
    pose:function(o){
      o.ry = 0.04*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.05 + 0.05*o.mv + o.tel*0.16 - o.atk*0.30;
      o.rz = -o.tel*0.26 + o.atk*1.05;
    }
  },
  {
    id:'luke', fam:'wall', code:'LUKE', zh:'艙門', role:'掩體・射擊', tint:'amb',
    sil:'直立矩形＋中央開縫', h:1.48, w:1.18, wt:0.9,
    spd:1.3, turn:1.4, gait:1.7, rng:6.0, tTel:0.70, tAtk:0.30, tRec:0.95,
    q0:{lg:1, sh:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速開', q:{sh:0.84}, sp:1.36, sc:0.90},
          {n:'厚門', q:{sh:1.22}, sp:0.70, sc:1.14}],
    parts:[
      pt('box','armor',[1.06,0.50,0.18],[0,1.20,0.30],[-0.08,0,0], function(P,o){
          P.sx *= o.q.sh; P.y += o.tel*0.24; }),
      pt('box','armor',[1.06,0.50,0.18],[0,0.66,0.30],[-0.08,0,0], function(P,o){
          P.sx *= o.q.sh; P.y -= o.tel*0.20; }),
      pt('bev','dark', [0.54,0.56,0.58],[0,0.92,-0.14]),
      pt('cyl','armor',[0.18,0.78,0.18],[0,0.94,0.24],[HP,0,0], function(P,o){
          P.z += o.tel*0.28 - o.atk*0.26; }),
      pt('tor','glow', [0.30,0.30,0.6],[0,0.94,0.64],null, function(P,o){
          P.z += o.tel*0.28 - o.atk*0.26;
          var k = 1 + 1.2*o.tel + 2.6*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','armor',[0.22,0.66,0.22],[ 0.30,0.33,-0.06],null, legSwing( 1,0.33,0.30)),
      pt('cyl','armor',[0.22,0.66,0.22],[-0.30,0.33,-0.06],null, legSwing(-1,0.33,0.30))
    ],
    ex:[ pt('box','armorE',[0.22,1.06,0.14],[ 0.60,0.94,0.26],[0,0,-0.16]),
         pt('box','armorE',[0.22,1.06,0.14],[-0.60,0.94,0.26],[0,0, 0.16]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.04 + 0.04*o.mv - o.tel*0.08;
      o.rz = -o.atk*0.10;
    }
  },
  {
    id:'pforte', fam:'wall', deep:1, code:'PFORTE', zh:'門', role:'深層・可穿透的牆', tint:'vio',
    sil:'直立框・中間看得穿', h:1.60, w:1.24, wt:0.7,
    spd:1.2, turn:1.3, gait:1.6, rng:5.4, tTel:1.05, tAtk:0.50, tRec:1.25,
    q0:{lg:1, fr:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'窄門', q:{fr:0.80}, sp:1.38, sc:0.90},
          {n:'闊門', q:{fr:1.26}, sp:0.70, sc:1.14}],
    parts:[
      pt('box','armor',[0.20,1.24,0.26],[ 0.50,0.96,0.14], null, function(P,o){ P.x *= o.q.fr; }),
      pt('box','armor',[0.18,1.10,0.24],[-0.46,0.90,0.06],[0,0,0.10], function(P,o){ P.x *= o.q.fr; }),
      pt('box','armor',[1.20,0.22,0.26],[0.02,1.56,0.12],[0,0,-0.06], function(P,o){ P.sx *= o.q.fr; }),
      pt('oct','void',[1.00,1.10,0.30],[0.02,0.96,0.10], null, function(P,o){
          P.sx *= o.q.fr*(1 + 0.5*o.tel); P.sy *= 1 + 0.5*o.tel; }),
      pt('tor','glow',[1.30,1.44,0.26],[0.02,0.96,0.16], null, function(P,o){
          P.sx *= o.q.fr; P.rz += o.t*(0.4 + 3.5*o.tel);
          var k = 1 + 0.5*o.tel + 1.4*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','trim',[0.22,0.68,0.22],[ 0.34,0.34,-0.04], null, legSwing( 1,0.34,0.30)),
      pt('cyl','trim',[0.20,0.60,0.20],[-0.32,0.30, 0.06], null, legSwing(-1,0.30,0.34))
    ],
    ex:[ pt('box','armorE',[0.24,0.34,0.20],[0.62,1.56,0.10],[0,0,-0.3]),
         pt('oct','glowE',[0.20,0.20,0.20],[-0.56,1.44,0.06]) ],
    pose:function(o){ o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.04 + 0.04*o.mv; o.rr = -0.06 + 0.08*Math.sin(o.ph*Math.PI * 2)*o.mv; }
  }
];
